/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Account } from '../models/account';
import { AccountPagedData } from '../models/account-paged-data';
import { changeEmailAddress } from '../fn/account/change-email-address';
import { ChangeEmailAddress$Params } from '../fn/account/change-email-address';
import { Company } from '../models/company';
import { createAccount } from '../fn/account/create-account';
import { CreateAccount$Params } from '../fn/account/create-account';
import { deleteAccount } from '../fn/account/delete-account';
import { DeleteAccount$Params } from '../fn/account/delete-account';
import { getAccount } from '../fn/account/get-account';
import { GetAccount$Params } from '../fn/account/get-account';
import { getAccounts } from '../fn/account/get-accounts';
import { GetAccounts$Params } from '../fn/account/get-accounts';
import { getCurrentAccount } from '../fn/account/get-current-account';
import { GetCurrentAccount$Params } from '../fn/account/get-current-account';
import { getFavoriteCompanies } from '../fn/account/get-favorite-companies';
import { GetFavoriteCompanies$Params } from '../fn/account/get-favorite-companies';
import { getFavoriteJobPostings } from '../fn/account/get-favorite-job-postings';
import { GetFavoriteJobPostings$Params } from '../fn/account/get-favorite-job-postings';
import { getRoles } from '../fn/account/get-roles';
import { GetRoles$Params } from '../fn/account/get-roles';
import { JobPosting } from '../models/job-posting';
import { registerAccount } from '../fn/account/register-account';
import { RegisterAccount$Params } from '../fn/account/register-account';
import { Role } from '../models/role';
import { updateAccount } from '../fn/account/update-account';
import { UpdateAccount$Params } from '../fn/account/update-account';
import { updateCurrentAccount } from '../fn/account/update-current-account';
import { UpdateCurrentAccount$Params } from '../fn/account/update-current-account';
import { uploadAccountAvatar } from '../fn/account/upload-account-avatar';
import { UploadAccountAvatar$Params } from '../fn/account/upload-account-avatar';

@Injectable({ providedIn: 'root' })
export class AccountService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAccounts()` */
  static readonly GetAccountsPath = '/account';

  /**
   * Gets all accounts for account management [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccounts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccounts$Response(params?: GetAccounts$Params, context?: HttpContext): Observable<StrictHttpResponse<AccountPagedData>> {
    const obs = getAccounts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all accounts for account management [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccounts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccounts(params?: GetAccounts$Params, context?: HttpContext): Observable<AccountPagedData> {
    const resp = this.getAccounts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AccountPagedData>): AccountPagedData => r.body)
    );
  }

  /** Path part for operation `createAccount()` */
  static readonly CreateAccountPath = '/account';

  /**
   * Creates a new account [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAccount()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAccount$Response(params?: CreateAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<Account>> {
    const obs = createAccount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new account [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAccount$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAccount(params?: CreateAccount$Params, context?: HttpContext): Observable<Account> {
    const resp = this.createAccount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Account>): Account => r.body)
    );
  }

  /** Path part for operation `getAccount()` */
  static readonly GetAccountPath = '/account/{id}';

  /**
   * Gets the specified account for account management [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccount$Response(params: GetAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<Account>> {
    const obs = getAccount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified account for account management [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccount(params: GetAccount$Params, context?: HttpContext): Observable<Account> {
    const resp = this.getAccount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Account>): Account => r.body)
    );
  }

  /** Path part for operation `updateAccount()` */
  static readonly UpdateAccountPath = '/account/{id}';

  /**
   * Updates the specified account [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAccount()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAccount$Response(params: UpdateAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<Account>> {
    const obs = updateAccount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified account [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAccount$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAccount(params: UpdateAccount$Params, context?: HttpContext): Observable<Account> {
    const resp = this.updateAccount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Account>): Account => r.body)
    );
  }

  /** Path part for operation `deleteAccount()` */
  static readonly DeleteAccountPath = '/account/{id}';

  /**
   * Deletes the specified account [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAccount$Response(params: DeleteAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteAccount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified account [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAccount(params: DeleteAccount$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteAccount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getRoles()` */
  static readonly GetRolesPath = '/account/roles';

  /**
   * Gets all account roles [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles$Response(params?: GetRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Role>>> {
    const obs = getRoles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all account roles [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles(params?: GetRoles$Params, context?: HttpContext): Observable<Array<Role>> {
    const resp = this.getRoles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Role>>): Array<Role> => r.body)
    );
  }

  /** Path part for operation `registerAccount()` */
  static readonly RegisterAccountPath = '/account/register/{accountType}';

  /**
   * Registers a new account for the currently logged in user. [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerAccount()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerAccount$Response(params: RegisterAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<Account>> {
    const obs = registerAccount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Registers a new account for the currently logged in user. [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerAccount$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registerAccount(params: RegisterAccount$Params, context?: HttpContext): Observable<Account> {
    const resp = this.registerAccount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Account>): Account => r.body)
    );
  }

  /** Path part for operation `getCurrentAccount()` */
  static readonly GetCurrentAccountPath = '/account/current';

  /**
   * Gets the account for the currently logged in user. [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentAccount$Response(params?: GetCurrentAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Account>>> {
    const obs = getCurrentAccount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the account for the currently logged in user. [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCurrentAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentAccount(params?: GetCurrentAccount$Params, context?: HttpContext): Observable<Array<Account>> {
    const resp = this.getCurrentAccount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Account>>): Array<Account> => r.body)
    );
  }

  /** Path part for operation `updateCurrentAccount()` */
  static readonly UpdateCurrentAccountPath = '/account/current';

  /**
   * Updates the current account [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCurrentAccount()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCurrentAccount$Response(params?: UpdateCurrentAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateCurrentAccount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the current account [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCurrentAccount$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCurrentAccount(params?: UpdateCurrentAccount$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateCurrentAccount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `uploadAccountAvatar()` */
  static readonly UploadAccountAvatarPath = '/account/{id}/avatar';

  /**
   * Saves the avatar image for the specified account [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadAccountAvatar()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadAccountAvatar$Response(params: UploadAccountAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = uploadAccountAvatar(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Saves the avatar image for the specified account [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadAccountAvatar$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadAccountAvatar(params: UploadAccountAvatar$Params, context?: HttpContext): Observable<void> {
    const resp = this.uploadAccountAvatar$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `changeEmailAddress()` */
  static readonly ChangeEmailAddressPath = '/account/{id}/emailaddress';

  /**
   * Provides the possibility to change the email-address for accounts that do not use
   * an external auth provider (google, facebook) [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeEmailAddress()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changeEmailAddress$Response(params: ChangeEmailAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = changeEmailAddress(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Provides the possibility to change the email-address for accounts that do not use
   * an external auth provider (google, facebook) [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeEmailAddress$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  changeEmailAddress(params: ChangeEmailAddress$Params, context?: HttpContext): Observable<void> {
    const resp = this.changeEmailAddress$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getFavoriteCompanies()` */
  static readonly GetFavoriteCompaniesPath = '/account/{accountId}/favorites/companies';

  /**
   * Gets the companies on the user's favorites list [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFavoriteCompanies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFavoriteCompanies$Response(params: GetFavoriteCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Company>>> {
    const obs = getFavoriteCompanies(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the companies on the user's favorites list [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFavoriteCompanies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFavoriteCompanies(params: GetFavoriteCompanies$Params, context?: HttpContext): Observable<Array<Company>> {
    const resp = this.getFavoriteCompanies$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Company>>): Array<Company> => r.body)
    );
  }

  /** Path part for operation `getFavoriteJobPostings()` */
  static readonly GetFavoriteJobPostingsPath = '/account/{accountId}/favorites/jobpostings';

  /**
   * Gets the job postings on the user's favorites list [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFavoriteJobPostings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFavoriteJobPostings$Response(params: GetFavoriteJobPostings$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<JobPosting>>> {
    const obs = getFavoriteJobPostings(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the job postings on the user's favorites list [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFavoriteJobPostings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFavoriteJobPostings(params: GetFavoriteJobPostings$Params, context?: HttpContext): Observable<Array<JobPosting>> {
    const resp = this.getFavoriteJobPostings$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<JobPosting>>): Array<JobPosting> => r.body)
    );
  }

}
